import React from 'react';
import ImageZoom from 'react-medium-image-zoom';
import ProjectHeader from './ProjectHeader';

import coverImg from '../../imgs/UpZone/coverImg-UpZone.png';
import upcycleImg from '../../imgs/UpZone/upcycle.png';
import quoteImg from '../../imgs/UpZone/quote.png';
import gameCardImg from '../../imgs/UpZone/gameCard.png';
import appPlayGif from '../../imgs/UpZone/appPlay.gif';
import appMaterialCardGif from '../../imgs/UpZone/appMaterialCard.gif';
import appActionCardGif from '../../imgs/UpZone/appActionCard.gif';
import appThemeCardGif from '../../imgs/UpZone/appThemeCard.gif';
import userGoalImg from '../../imgs/UpZone/userGoal.png';
import insightsImg from '../../imgs/UpZone/insights.png';
import affinityImg from '../../imgs/UpZone/affinity.png';
import ideationImg from '../../imgs/UpZone/ideation.png';
import designRequirementsImg from '../../imgs/UpZone/designRequirements.png';
import gameRuleEvolveImg from '../../imgs/UpZone/gameRuleEvolve.png';
import cardGameImg from '../../imgs/UpZone/cardGame.png';
import addressingRequirementsMaterialCardImg from '../../imgs/UpZone/addressingRequirementsMaterialCard.png';
import addressingRequirementsSettingsImg from '../../imgs/UpZone/addressingRequirementsSettings.png';
import addressingRequirementsPhotoLibraryImg from '../../imgs/UpZone/addressingRequirementsPhotoLibrary.png';
import styleGuideImg from '../../imgs/UpZone/styleGuide.png';
import addressingRequirementsCardImg from '../../imgs/UpZone/addressingRequirementsCard.png';

const UpZone = () => {
  return (
    <div className="caseBody" id="upzone">
      <ProjectHeader
        projectName="UpZone: Creative Eco-Design Game"
        // subtitle="Cooleaf Spnsored"
        bulletPoints={[
          {
            name: 'Discipline',
            content:
              'User Research, Product Design, Product Thinking and Project Management'
          },
          {
            name: 'Role',
            content: 'Product Designer + Project Manager'
          },
          {
            name: 'Team',
            content: {
              __html:
                '<a href="https://www.parharyugvir.com" target="_blank">Yugvir Parhar</a>, <a href="https://www.linkedin.com/in/taylorbunge/" target="_blank">Taylor Bunge</a>, <a href="https://www.linkedin.com/in/madeleine-paulsen-82379a144/" target="_blank">Madeleine Paulsen</a>'
            },
            isHTML: true
          },
          {
            name: 'Timeline',
            content: 'Aug - Dec 2021'
          },
          {
            name: 'Tools',
            content: 'Google Doc, Miro, Figma, Pen + Paper'
          }
        ]}
        imgSrc={coverImg}
      />
      <section className="mainSec">
        <div className="left">
          <h3 id="overview">Project Overview</h3>
        </div>
        <div className="right">
          <p className="content-p">
            This project focused on sustainability. The purpose of UpZone is to
            address the barriers parents face when upcycling and to further
            support their current practices and goals. We applied user-centered
            design strategies and an evidence-based design process to address
            the upcycle problem and encourage sustainable behaviors.
          </p>
          <ImageZoom
            image={{
              src: upcycleImg,
              alt: 'upcycle',
              className: 'img-responsive img-centered'
            }}
          />
          <h4>Problem</h4>
          <p className="content-p">
            Upcycling conserves more energy, less water expenditure, and
            produces fewer emissions than recycling. Through research insights,
            we found that “Family and Children” are the most common group within
            an online upcycling community. They motivated by extrinsic and
            intrinsic motivations. However, parents face barriers including lack
            of materials and supplies, ideas and inspiration, and time.
          </p>
          {/* <h4>Outcome</h4>
          <p className="content-p">
            In order to address this problem, we designed a mobile app to help
            the patrons of the Seattle Public Library easily explore and locate
            its variety of resources in the library space.
          </p> */}
          <ImageZoom
            image={{
              src: quoteImg,
              alt: 'quote',
              className: 'img-responsive img-centered'
            }}
          />
        </div>
      </section>
      <section className="mainSec">
        <div className="left">
          <h3 id="solution">Solution</h3>
        </div>
        <div className="right">
          <p className="content-p">
            UpZone is an upcycling card game with a mobile app that supports
            families to upcycle household items in a collaborative and creative
            way.
          </p>
          <p className="content-p">
            In this game, players work together in 3 rounds to gather materials,
            brainstorm project ideas, and build new creations using materials
            found in their own home. Players use the prompt cards provided to
            inspire creativity and enter the Up Zone before time runs out.
          </p>
        </div>
      </section>
      <section className="mainSec flex-initial">
        <div className="left">
          <h3 id="game-card">I. Game Card and Pamphlet</h3>
          <p className="content-p">
            The game contains cards, tokens and pamphlet. Parent and children
            follow the instructions to play the upcycling game with exitsting
            household items.
          </p>
        </div>
        <div className="right">
          <ImageZoom
            image={{
              src: gameCardImg,
              alt: 'game card and pamphlet',
              className: 'img-responsive img-centered margin-top-bottom-sm'
            }}
          />
        </div>
      </section>
      <section className="mainSec flex-initial">
        <div className="left">
          <h3>II. UpZone App</h3>
          <p className="content-p">
            The app is designed to assist the card game in a family context. The
            app supports the scanning function as well as getting project
            inspiration.
          </p>
          <p className="content-p">
            i. the game consists of three rounds. Instruction reminders are
            provided in each round with a timer to facilitate the gameplay.
          </p>
        </div>
        <div className="right">
          <ImageZoom
            image={{
              src: appPlayGif,
              alt: 'upzone app',
              className: 'img-responsive img-centered img-40-percent-size'
            }}
          />
        </div>
      </section>
      <section className="mainSec flex-initial">
        <div className="left">
          <p className="content-p">
            ii. the material cards and extra information after scanning them or
            navigating to the card through the app.
          </p>
        </div>
        <div className="right">
          <ImageZoom
            image={{
              src: appMaterialCardGif,
              alt: 'upzone app',
              className: 'img-responsive img-centered img-40-percent-size'
            }}
          />
        </div>
      </section>
      <section className="mainSec flex-initial">
        <div className="left">
          <p className="content-p">
            iii. all the action cards to provide additional card deck and
            potentially for future expansions.
          </p>
        </div>
        <div className="right">
          <ImageZoom
            image={{
              src: appActionCardGif,
              alt: 'upzone app',
              className: 'img-responsive img-centered img-40-percent-size'
            }}
          />
        </div>
      </section>
      <section className="mainSec flex-initial">
        <div className="left">
          <p className="content-p">
            iv. the inspiration page after scanning a build card or navigating
            to the card through the app.
          </p>
        </div>
        <div className="right">
          <ImageZoom
            image={{
              src: appThemeCardGif,
              alt: 'upzone app',
              className: 'img-responsive img-centered img-40-percent-size'
            }}
          />
        </div>
      </section>
      <section className="mainSec">
        <div className="left">
          <h3 id="user-research">User Research</h3>
        </div>
        <div className="right">
          <h4>Literature Research</h4>
          <p className="content-p">
            <strong>Rationale:</strong> We looked for empirical evidence to
            support our study. We used literature reviews about upcycling,
            competitive analysis of products and services to support upcycling.
          </p>
          <p className="content-p">
            This helped us to narrow down our project scope, understand people
            who are upcycling, their personality, beliefs, and motivations, etc,
            and to identify parental attitudes towards upcycling and user goals.
          </p>
          <h4>User Goals</h4>
          <ImageZoom
            image={{
              src: userGoalImg,
              alt: 'user goal',
              className: 'img-responsive img-centered margin-top-bottom-sm'
            }}
          />

          <h4>Survey</h4>
          <p className="content-p">
            <strong>Rationale:</strong> Survey allowed us to efficiently capture
            data from a large sample size of our target population. It also
            enabled us to gather contact information from individuals willing to
            participate in follow up interviews. This survey was an effective
            research tool that broadly captured the characteristics, practices,
            motivations, and challenges among parents who upcycle. It also
            allowed us to validate the user goals and tasks we identified from
            our literature research and observations of online upcycling
            communities.
          </p>

          <p className="content-p">
            <strong>Procedure:</strong> We first engaged with our target
            population using a 17-question survey. Each question was designed
            with rationale behind. They were transferred to Qualtrics and I
            distributed them to online groups and communities.
          </p>
          <p className="content-p">
            We received 108 responses to our survey within one week. We then
            screened these responses to focus on our user group and this left us
            with 40 qualifying responses that we used for analysis.{' '}
          </p>

          <h4>Semi-structured Interviews</h4>
          <p className="content-p">
            <strong>Rationale:</strong> Semi-structured interviews allowed us to
            gain a deeper understanding of our interviewees’ upcycling behaviors
            as well as their motivations and goals when completing the activity.
            We were able to dive deeper into how parents upcycle with their
            children and how their children respond and engage with upcycling.
          </p>

          <p className="content-p">
            <strong>Procedure:</strong> After analyzing the survey responses, we
            brainstormed our interview questions based on the information we
            wanted to gain in more detail. I reached out to the 8 individuals
            who provided their contact information in our survey and conducted 4
            semi-structured interview sessions.
          </p>
        </div>
      </section>
      <section className="mainSec">
        <div className="left">
          <h3 id="insights">Insights</h3>
        </div>
        <div className="right">
          <p className="content-p">
            We used affinity mapping techniques to analyze the notes. Using
            Miro, we were able to collaborate and organize our data into an
            affinity diagram.
          </p>
        </div>
      </section>
      <scction className="mainSec">
        <div className="full-width-break-out margin-top-bottom-md">
          <ImageZoom
            image={{
              src: affinityImg,
              alt: 'affinity diagram',
              className: 'img-responsive img-centered'
            }}
          />
        </div>
      </scction>
      <section className="mainSec">
        <div className="left" />
        <div className="right">
          <ImageZoom
            image={{
              src: insightsImg,
              alt: 'insights',
              className: 'img-responsive img-centered margin-top-bottom-sm'
            }}
          />
        </div>
      </section>
      <section className="mainSec">
        <div className="left">
          <h3 id="ideations">Ideations</h3>
        </div>
        <div className="right">
          <p className="content-p">
            While funneling through our research, we followed the Disney method
            for brainstorming. The Disney method includes 3 distinct categories
            of ideas: dreamer, realist, and critique.
          </p>
          <p className="content-p">
            Each team member initially came up with 10 design concepts that help
            our target user group to reach their goals, overcome their
            constraints, and accommodate their attributes.
          </p>
          <p className="content-p">
            Our 10 designs funneled into 2 final ideas that we will then build
            on in the future to develop our final prototype.
          </p>
        </div>
      </section>
      <scction className="mainSec">
        <div className="full-width-break-out margin-top-bottom-md">
          <ImageZoom
            image={{
              src: ideationImg,
              alt: 'ideation',
              className: 'img-responsive img-centered'
            }}
          />
        </div>
      </scction>
      <section className="mainSec">
        <div className="left">
          <h3 id="prototype">Design Requirements and Lo-fi Prototype</h3>
        </div>
        <div className="right">
          <p className="content-p">
            The findings from research with our target population informed the
            creation of both functional and non-functional design requirements
            for our prototype. The product should ...
          </p>
          <ImageZoom
            image={{
              src: designRequirementsImg,
              alt: 'design requirements',
              className: 'img-responsive img-centered margin-top-bottom-sm'
            }}
          />
        </div>
      </section>
      <section className="mainSec">
        <div className="left" />
        <div className="right">
          <p className="content-p">
            We did our initial game design on the floor of our HCI lounge and on
            the whiteboard in front of our dean’s office c: Kudos to our friends
            who generously gave us feedback and inspired us to create UpZone!
          </p>
          <p className="content-p">
            How game rules evolved from initally a competitve game to a
            collaborative game:
          </p>
        </div>
      </section>
      <scction className="mainSec">
        <div className="full-width-break-out margin-top-bottom-md">
          <ImageZoom
            image={{
              src: gameRuleEvolveImg,
              alt: 'how game rules envole',
              className: 'img-responsive img-centered'
            }}
          />
        </div>
      </scction>
      <section className="mainSec">
        <div className="left">
          <h3 id="vieo-prototype">Video Prototype</h3>
        </div>
        <div className="right">
          <p className="content-p">
            In order to display the full context of the solution, we prepared a
            video prototype as our main prototype for UpZone. We wanted to
            display its full potential to users which would best be done with a
            video prototype of the game.{' '}
          </p>
          <div className="margin-top-bottom-sm">
            <iframe
              width="100%"
              height="450"
              src="https://www.youtube.com/embed/YKNAtJsLE7k"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullscreen
            />
          </div>
        </div>
      </section>
      <section className="mainSec flex-initial">
        <div className="left">
          <h3 id="hifi-prototype">Hi-fi screens</h3>
        </div>
        <div className="right">
          <div className="margin-top-bottom-sm">
            <iframe
              style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}
              width="100%"
              height="450"
              src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2F4lTrmbBM6Fcb8OtL011kIG%2FUpzone---prototype%3Fpage-id%3D0%253A1%26node-id%3D2%253A911%26viewport%3D259%252C48%252C0.1%26scaling%3Dscale-down%26starting-point-node-id%3D2%253A911%26show-proto-sidebar%3D1"
              allowFullscreen
            />
          </div>
        </div>
      </section>

      <section className="mainSec">
        <div className="left">
          <h3 id="card-game">Card game</h3>
        </div>
        <div className="right">
          <p className="content-p">
            <strong>Material cards (yellow)</strong> are distributed to players
            before the start of Round 1. Examples of common items to look for
            are listed on each card. Players can also scan the QR code to learn
            about the environmental impact and biodegradability of their
            materials.
          </p>
          <p className="content-p">
            <strong>Action cards (blue)</strong> provide action prompts that
            players are encouraged to complete when building their upcycled
            project. Action cards give players an additional creative challenge
            and inspire players to be more innovative when brainstorming and
            building their ideas.
          </p>
          <p className="content-p">
            <strong>Build cards (green)</strong> contain the project concepts
            that guide players on what to upcycle. There are two types of Build
            cards: Craft cards and Theme cards differentiated by the stripe on
            the back of each card. If players get stuck or need even more
            inspiration, they may scan the QR code to view specific examples of
            that upcycled project in the Up Zone app.
          </p>
        </div>
      </section>
      <section className="mainSec">
        <div className="full-width-break-out margin-top-bottom-md">
          <ImageZoom
            image={{
              src: cardGameImg,
              alt: 'card game',
              className: 'img-responsive img-centered'
            }}
          />
        </div>
      </section>

      <section className="mainSec flex-initial">
        <div className="left">
          <h3 id="addresing-requirements">
            UpZone: <br />
            Addressing Design Requirements
          </h3>
        </div>
        <div className="right">
          {/* addressing requiremnts 1 */}
          <div>
            {/* <ImageZoom
              image={{
                src: addressingRequirements1Img,
                alt: 'addressing requirements 1',
                className: 'img-responsive img-centered margin-top-bottom-sm'
              }}
            /> */}
            <h4>
              1. The product should provide feedback on users’ environmental
              impact.
            </h4>
            <p className="content-p">
              Users can scan the QR code on any Material card which takes them
              to more information and facts about that material in the app. Each
              material card is labeled with a different colored “Earth” icon to
              show the degradation rates of everyday household materials in a
              simple manner.
            </p>
            <ImageZoom
              image={{
                src: addressingRequirementsMaterialCardImg,
                alt: 'addressing requirements material card',
                className: 'img-responsive img-centered margin-top-bottom-sm'
              }}
            />
          </div>

          {/* addressing requiremnts 2 */}
          {/* <ImageZoom
            image={{
              src: addressingRequirements2Img,
              alt: 'addressing requirements 2',
              className: 'img-responsive img-centered margin-top-bottom-sm'
            }}
          /> */}
          <h4>2. The product should allow customizable user settings.</h4>
          <p className="content-p">
            Up Zone allows parents to play by themselves or with their family!
            It allows adjustable timer lengths and resume the game at their own
            pace. The deliberately high-level theme cards give users as much
            freedom to use their materials as possible.
          </p>
          <ImageZoom
            image={{
              src: addressingRequirementsSettingsImg,
              alt: 'addressing requirements settings',
              className: 'img-responsive img-centered margin-top-bottom-sm'
            }}
          />

          {/* addressing requiremnts 3 */}
          {/* <ImageZoom
            image={{
              src: addressingRequirements3Img,
              alt: 'addressing requirements 3',
              className: 'img-responsive img-centered margin-top-bottom-sm'
            }}
          /> */}
          <h4>
            3. The product should connect users to materials and ideas and
            encourage collaboration.
          </h4>
          <p className="content-p">
            This requirement informed our design of the Material cards which
            were generated directly from our user research about what Materials
            and tools parents use most to upcycle. The QR code functionality
            leading to a photo library of ideas for each Build card was also
            implemented to fulfill this functional requirement.
          </p>
          <ImageZoom
            image={{
              src: addressingRequirementsPhotoLibraryImg,
              alt: 'addressing requirements photo library',
              className: 'img-responsive img-centered margin-top-bottom-sm'
            }}
          />

          {/* addressing requiremnts 4 */}
          {/* <ImageZoom
            image={{
              src: addressingRequirements4Img,
              alt: 'addressing requirements 4',
              className: 'img-responsive img-centered margin-top-bottom-sm'
            }}
          /> */}
          <h4>4. The product should be engaging for the user.</h4>
          <p className="content-p">
            The UpZone game engages users throughout the entire upcycling
            process beyond the idea generation and material gathering phases
            that existing apps already fulfill. UpZone is engaging in how it
            provides an opportunity for parents to spend time with their
            children as well.
          </p>

          {/* addressing requiremnts 5 */}
          {/* <ImageZoom
            image={{
              src: addressingRequirements5Img,
              alt: 'addressing requirements 5',
              className: 'img-responsive img-centered margin-top-bottom-sm'
            }}
          /> */}
          <h4>5. The product should be designed simply.</h4>
          <p className="content-p">
            The simple app design and consistent color palette increase
            learnability and decrease the amount of time spent navigating the
            app. We also deliberately used simple language, playful graphics,
            and easy-to-read fonts to appeal to players of all ages.
          </p>
          <ImageZoom
            image={{
              src: styleGuideImg,
              alt: 'style guide',
              className: 'img-responsive img-centered margin-top-bottom-sm'
            }}
          />

          {/* addressing requiremnts 6 */}
          {/* <ImageZoom
            image={{
              src: addressingRequirements6Img,
              alt: 'addressing requirements 6',
              className: 'img-responsive img-centered margin-top-bottom-sm'
            }}
          /> */}
          <h4>6. The product should be trustworthy.</h4>
          <p className="content-p">
            We designed Up Zone with feasibility in mind, so users can trust
            that they can play and have an enjoyable experience. Specifically,
            the Build card prompts were chosen for their ability to be created
            with lots of different types of materials. The Theme and Craft cards
            are specific enough to help players come up with ideas, but not too
            specific that players could not create the projects using materials
            easily found around the home. We also reduced the risk that users
            may upcycle with potentially hazardous materials since users are
            sourcing all of their materials from their home.
          </p>
          <ImageZoom
            image={{
              src: addressingRequirementsCardImg,
              alt: 'addressing requirements card',
              className: 'img-responsive img-centered margin-top-bottom-sm'
            }}
          />

          {/* addressing requiremnts 7 */}
          {/* <ImageZoom
            image={{
              src: addressingRequirements7Img,
              alt: 'addressing requirements 7',
              className: 'img-responsive img-centered margin-top-bottom-sm'
            }}
          /> */}
          <h4>7. The product should inspire creativity.</h4>
          <p className="content-p">
            UpZone is the ultimate creative upcycling game. UpZone gives users
            unique challenges and constraints to work under to build new
            upcycled projects using the items they have in their home. Rather
            than giving users specific project ideas like every other app and
            website on the market, UpZone gives users a creative framework for
            generating upcycling project ideas on their own! And if users get
            stuck or need more structure, they have the option to view a library
            of examples using the QR code on the Build card.
          </p>

          {/* addressing requiremnts 8 */}
          {/* <ImageZoom
            image={{
              src: addressingRequirements8Img,
              alt: 'addressing requirements 8',
              className: 'img-responsive img-centered margin-top-bottom-sm'
            }}
          /> */}
          <h4>
            8. The product should not impose an undue financial burden to the
            user.
          </h4>
          <p className="content-p">
            UpZone encourages users to upcycle with items they already own to
            prevent them from needing to buy new supplies! The only current
            financial burden to users is the cost of printing the game itself.
          </p>
        </div>
      </section>
    </div>
  );
};

export default UpZone;



// WEBPACK FOOTER //
// ./src/Modules/Case/UpZone.js